export default "__VITE_PUBLIC_ASSET__11a26d30__"